import React from "react";
import ExitModalIcon from "../../shared/Icons/ExitModalIcon";
import { Imagem, ModalContainer, ModalWrapper } from "./style";

interface IProps {
  src: string;
  setShowModal: React.Dispatch<boolean>;
}

export const BannerModal = ({setShowModal, src}: IProps) => {
return (
  <ModalWrapper>
    <ModalContainer>
      <ExitModalIcon
        previewImageModal
        onClick={() => setShowModal(false)}
        style={{ alignSelf: "end" }}
      />
      <Imagem src={src} alt="banner preview" id="imageId" />
    </ModalContainer>
  </ModalWrapper>
);
}